import Button from "../../../../components/bootstrap/Button";
import Card, { CardFooterRight, CardTabItem } from "../../../../components/bootstrap/Card";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../../../components/bootstrap/Modal";

interface Props {
    isModalOpened: boolean;
    selectedEvidenceImage: string;
    onModalClose: () => void;
    onAfterSubmit: () => void;
}

export const AnsweredSurveyDetailModal = ({ isModalOpened, selectedEvidenceImage, onModalClose, onAfterSubmit }: Props) => {

    const onClose = () => {
        onModalClose();
    };

    return (
        <Modal isOpen={isModalOpened} setIsOpen={onClose} size={'lg'} isCentered isStaticBackdrop>
            <ModalHeader setIsOpen={onClose}>
                <ModalTitle id='company-modal'>Evidência</ModalTitle>
            </ModalHeader>
            <ModalBody>
                
                <Card hasTab tabButtonColor='primary'>

                    <CardTabItem id='tab-item-1' title='Imagem de evidência' icon='Image'>
                        <div className='row g-4'>
                            <img src={selectedEvidenceImage} alt='preview' width='100%' />
                        </div>
                    </CardTabItem>

                </Card>
            </ModalBody>
            <ModalFooter className='bg-transparent'>
                <CardFooterRight>
                    <Button color='primary' className='w-100' onClick={onClose}>
                        Fechar
                    </Button>
                </CardFooterRight>
            </ModalFooter>
        </Modal>
    );
}